import { Toast } from '@capacitor/toast';
import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonLoading, IonModal, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSegmentButton, IonSlide, IonSlides, IonTextarea, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import BeautyStars from 'beauty-stars';
import { albumsOutline, alertCircle, arrowBack, calendarOutline, flagOutline, informationCircleOutline, listOutline } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { avaliarProjeto, enviarMensagemCliente, listaProjeto, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import ClientePageHeader from '../../../../../components/ClientePageHeader';
import ProjetosCupom from '../ProjetosCupom/ProjetosCupom';
import './Ordens.css';

const Ordens: React.FC = () => {

  const history = useHistory();
  const [aba, setAba] = useState("proximos");
  const [arrayProjetos, setArrayProjetos] = useState<any>([]);
  const [chamadaRealizada, setChamadaRealizada] = useState(false);
  const [projetoId, setProjetoId] = useState("");
  const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
  const [projetopk, setProjetopk] = useState("");
  const [showLoading, setShowLoading] = useState(true);
  const [alertaPreenchimento, setAlertaPreenchimento] = useState(false);
  const [valorEstrela, setValorEstrela] = useState(0);
  const [abrirAvaliar, setAbrirAvaliar] = useState(false);
  const [textoEstrela, setTextoEstrela] = useState("Selecione");
  const [comentario, setComentario] = useState("");
  const [showModalMensagem, setShowModalMensagem] = useState(false);
  const [mensagem, setMensagem] = React.useState<string>();
  const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const [showEncerrar, setShowEncerrar] = useState(false);
  const [projetoSelecionado, setProjetoSelecionado] = useState<any>();


  useIonViewDidEnter(() => {
    setChamadaRealizada(false);
    loadItens();
    window.localStorage.setItem("compartilhado", "false");
    setEsconderMenu(false);
  });

  let slides = useRef(document.createElement('ion-slides'));

  const nextSlide = () => {
    slides.current.getActiveIndex().then(
      isEnd => {
        if (isEnd === 1)
          setAba("anteriores")
        else
          setAba("proximos")
      }
    );
  }

  function pisca(valor: string) {
    if (valor === "Ativo") return "pisca piscaverde";
    else return "pisca";
  }

  function carregarDetalhes(configsLoja: any, projetoid: any, abrirInserirAgendamento: boolean) {
    setChamadaRealizada(false);
    history.push("ordens/ordensdetalhes", { projetoid: projetoid, configs: JSON.stringify(configsLoja), abrirInserirAgendamento: abrirInserirAgendamento })
  }

  function carregarAgendamentos(configsLoja: any, projetoid: any, abrirInserirAgendamento: boolean) {
    setChamadaRealizada(false);
    history.push("ordens/ordensagendamentos", { projetoid: projetoid, configs: JSON.stringify(configsLoja), abrirInserirAgendamento: abrirInserirAgendamento })
  }

  function carregarOperacoes(configsLoja: any, projetoid: any, abrirInserirAgendamento: boolean) {
    setChamadaRealizada(false);
    history.push("ordens/ordensoperacoes", { projetoid: projetoid, configs: JSON.stringify(configsLoja), abrirInserirAgendamento: abrirInserirAgendamento })
  }

  function carregarWorkflow(configsLoja: any, projetoid: any) {

    setChamadaRealizada(false);
    history.push("ordens/ordensworkflow", { projetoid: projetoid, configs: JSON.stringify(configsLoja), abrirInserirAgendamento: false })

  }

  const loadItens = () => {

    if (!chamadaRealizada) {
      setChamadaRealizada(true);
      carregarProjetos();
    }

    if (arrayProjetos === undefined || arrayProjetos.length === 0) {
      return (
        <IonCard key="primeira">
          <IonCardHeader >
            <IonCardTitle>Aguarde, em instantes teremos novidades para você.</IonCardTitle>
            <IonCardSubtitle></IonCardSubtitle>
            <IonLabel></IonLabel>
          </IonCardHeader>
          <IonCardContent>
          </IonCardContent>
        </IonCard>
      );
    }

    return arrayProjetos.map((value: any, index: any, arr: any) =>
      (index === 0 || (arr[index - 1] && new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10) !== new Date(arr[index - 1].dataCadastro).toLocaleString('pt-BR').substring(0, 10))) ?
        (<>
          <IonCard className={"card"} key={value.dataCadastro + index.toString()}>
            <IonCardHeader key={value.dataCadastro}>
              <IonCardTitle>
                <div className={"cabecalho"} >{new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10) === new Date().toLocaleString('pt-BR').substring(0, 10) ? "Hoje" : new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10)}</div>
              </IonCardTitle>
            </IonCardHeader>
          </IonCard>
          <IonCard key={"cartao" + value.id + index.toString()}>
            <IonCardHeader key={value.id}>
              <IonCardTitle>

                {value.empresaNome || "não identificado"}

                <div className="status">
                  <div className={pisca(value.status)}></div>
                </div>

              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent style={{ paddingBottom: 0 }}>
              <div>
                <IonLabel>{value && value.servicoTipo ? value.servicoTipo : "Projeto"}: {value.nomeProjeto}
                </IonLabel>
              </div>
              <div>
                <IonLabel>{value && value.nomeLinhaDoTempo ? value.nomeLinhaDoTempo : "Status"}: {value.statusWorkflow || "não identificado"}</IonLabel>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }} hidden={value.avaliacaoCliente} >
                <IonButton size="small" slot="end" onClick={() => { setAbrirAvaliar(true); setProjetoId(value.pk.replaceAll(/#/g, '%23')); value.avaliacaoCliente ? setValorEstrela(value.avaliacaoCliente) : setValorEstrela(0); setComentario(value.comentarioCliente); console.log(value.comentarioCliente) }}>Avaliar</IonButton>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }} hidden={!value.avaliacaoCliente}>
                <BeautyStars size="16px"
                  value={value.avaliacaoCliente}
                  editable={false}
                />
              </div>


            </IonCardContent>

            <IonGrid style={{ padding: 0 }}>
              <IonRow >

                <IonCol size={value.layoutSimplificado ? '3' : '3'}>
                  <IonSegmentButton onClick={() => { carregarDetalhes(value.configWorkflow, value.pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={informationCircleOutline}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Detalhes</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size='2' hidden={value.layoutSimplificado}>
                  <IonSegmentButton onClick={() => { carregarWorkflow(value.configWorkflow, value.pk.replaceAll(/#/g, '%23')); }}>
                    <IonIcon icon={albumsOutline}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>{value && value.nomeLinhaDoTempo ? value.nomeLinhaDoTempo : "Linha do tempo"}</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size={value.layoutSimplificado ? '3' : '2'}>

                  <IonSegmentButton onClick={() => { setProjetoSelecionado(value); setShowEncerrar(true); }}>
                    <IonIcon icon={listOutline}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Cupom</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size={value.layoutSimplificado ? '3' : '2'}>

                  <IonSegmentButton onClick={() => { carregarAgendamentos(value.configWorkflow, value.pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={calendarOutline}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Agenda</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size={value.layoutSimplificado ? '3' : '3'}>
                  <IonSegmentButton onClick={() => { carregarOperacoes(value.configWorkflow, value.pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={flagOutline}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Operações</IonLabel>

                  </IonSegmentButton>

                </IonCol>

              </IonRow>
            </IonGrid>








          </IonCard >
        </>
        ) :
        (
          <IonCard key={"cartao" + value.id + index.toString()}>
            <IonCardHeader key={value.id}>
              <IonCardTitle>

                {value.empresaNome || "não identificado"}

                <div className="status">
                  <div className={pisca(value.status)}></div>
                </div>


              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent style={{ paddingBottom: 0 }}>
              <div>
                <IonLabel>{value && value.servicoTipo ? value.servicoTipo : "Projeto"}: {value.nomeProjeto}
                </IonLabel>
              </div>
              <div>
                <IonLabel>{value && value.nomeLinhaDoTempo ? value.nomeLinhaDoTempo : "Status"}: {value.statusWorkflow || "não identificado"}</IonLabel>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }} hidden={value.avaliacaoCliente} >
                <IonButton size="small" slot="end" onClick={() => { setAbrirAvaliar(true); setProjetoId(value.pk.replaceAll(/#/g, '%23')); value.avaliacaoCliente ? setValorEstrela(value.avaliacaoCliente) : setValorEstrela(0); setComentario(value.comentarioCliente); console.log(value.comentarioCliente) }}>Avaliar</IonButton>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }} hidden={!value.avaliacaoCliente}>
                <BeautyStars size="16px"
                  value={value.avaliacaoCliente}
                  editable={false}
                />
              </div>



            </IonCardContent>

            <IonGrid style={{ padding: 0 }}>
              <IonRow >

                <IonCol size={value.layoutSimplificado ? '3' : '2'}>
                  <IonSegmentButton onClick={() => { carregarDetalhes(value.configWorkflow, value.pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={informationCircleOutline}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Detalhes</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size='3' hidden={value.layoutSimplificado}>
                  <IonSegmentButton onClick={() => { carregarWorkflow(value.configWorkflow, value.pk.replaceAll(/#/g, '%23')); }}>
                    <IonIcon icon={albumsOutline}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>{value && value.nomeLinhaDoTempo ? value.nomeLinhaDoTempo : "Linha do tempo"}</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size={value.layoutSimplificado ? '3' : '2'}>

                  <IonSegmentButton onClick={() => { setProjetoSelecionado(value); setShowEncerrar(true); }}>
                    <IonIcon icon={listOutline}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Cupom</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size={value.layoutSimplificado ? '3' : '2'}>

                  <IonSegmentButton onClick={() => { carregarAgendamentos(value.configWorkflow, value.pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={calendarOutline}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Agenda</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size={value.layoutSimplificado ? '3' : '2'}>
                  <IonSegmentButton onClick={() => { carregarOperacoes(value.configWorkflow, value.pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={flagOutline}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Operações</IonLabel>

                  </IonSegmentButton>

                </IonCol>

              </IonRow>
            </IonGrid>
          </IonCard>
        )
    );

  }

  function carregarProjetos() {
    const consultar = async () => {

      requestService(listaProjeto.url, {
        method: listaProjeto.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          setArrayProjetos(response.Items);
          if (response.LastEvaluatedKey) {
            setProjetopk(response.LastEvaluatedKey.pk);
            setDesabilitarInfiniteScroll(false);
          }
          else {
            setProjetopk("");
            setDesabilitarInfiniteScroll(true);
          }
          setShowLoading(false);
        },
        (error: any) => {
          setShowLoading(false);
        });
    }

    consultar();
  }

  async function carregarMaisProjetos($event: CustomEvent<void>) {

    await carregarMaisProjetosChamada().then(() => {
      console.log("terminou resultados");
    });
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function carregarMaisProjetosChamada() {

    requestService(listaProjeto.url + "?pk=" + projetopk, {
      method: listaProjeto.method,
      headers: [
        ["token", window.localStorage.getItem("token")],
        ["perfil", window.localStorage.getItem("perfil")],
        ["marca", window.localStorage.getItem("marca") || ""],
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(arrayProjetos.length);
        for (let i = 0; i < response.Items.length; i++) {
          console.log("resultados");
          arrayProjetos.push(response.Items[i]);
        }
        console.log(arrayProjetos.length);
        if (response.LastEvaluatedKey) {
          setProjetopk(response.LastEvaluatedKey.pk);
          setDesabilitarInfiniteScroll(false);
        }
        else {
          setProjetopk("");
          setDesabilitarInfiniteScroll(true);
          console.log("finalizou");
        }
      },
      (error: any) => {
        console.log(error);
        if (error.status === 426) { // atualizar versao
          history.replace("/atualizar");
        }
        else if (error !== 408) {
          history.replace("/primeiroacesso/");
        }
      });
  }

  function doRefresh(event: any) {
    carregarProjetos();
    setTimeout(() => {
      event.detail.complete();
    }, 1200);
  }

  function ajustaTextoEstrela(value: any) {
    if (value === 1) setTextoEstrela("Muito ruim");
    if (value === 2) setTextoEstrela("Ruim");
    if (value === 3) setTextoEstrela("Normal");
    if (value === 4) setTextoEstrela("Bom");
    if (value === 5) setTextoEstrela("Excelente");
  }

  function avaliar() {
    const atualizar = async () => {
      requestService(avaliarProjeto.url, {
        method: avaliarProjeto.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        body: JSON.stringify({
          "id": projetoId,
          "avaliacao": valorEstrela + "",
          "comentario": comentario ? comentario + "" : "Sem comentário."
        }),
        credentials: 'include'
      },
        history,
        (response: any) => {
          if (response.message) {
            console.log(response);
            setAbrirAvaliar(false);
            carregarProjetos();
          }
        },
        (error: any) => {
          console.log(error);
        });
    }

    if (valorEstrela !== 0) {
      setAlertaPreenchimento(false);
      atualizar();
    }
    else {
      setAlertaPreenchimento(true);
    }

  }



  function enviarMensagem(pk: any) {

    console.log(pk.replaceAll(/#/g, "%23"));
    console.log(mensagem);
    if (!mensagem || mensagem.trim() == "") {
      setAlertaPreenchimento(true);
      return null;
    }

    let params = {
      mensagem: mensagem || ""
    }

    console.log("params", params);

    requestService(enviarMensagemCliente.url.replaceAll("{id}", pk.replaceAll(/#/g, "%23")), {
      method: enviarMensagemCliente.method,
      headers: [
        ["token", window.localStorage.getItem("token") || ""],
        ["perfil", window.localStorage.getItem("perfil") || ""],
        ["marca", window.localStorage.getItem("marca") || ""],
      ],
      body: JSON.stringify(params),
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(response);
        Toast.show({
          text: response.message,
          position: "center",
          duration: "long"
        });
        setShowModalMensagem(false);
      },
      (error: any) => {
        console.log(error);
        Toast.show({
          text: "Ocorreu um erro ao enviar a mensagem, tente novamente.",
          position: "center",
          duration: "long"
        });
      });




  }


  async function closeModalEncerrar() {
    setShowEncerrar(false);
  }

  async function closeModalEncerrarSucess() {
    setShowEncerrar(false);

  }

  return (
    <IonPage>
      <ClientePageHeader title={window.localStorage.getItem("servicoTipoPlural") || "Meus Pedidos"} />
      <IonContent className={"Ordens"}>

        {/* <IonFab vertical="bottom" horizontal="end" slot="fixed" edge style={{ "bottom": "20px" }} >
          <IonFabButton color="tertiary" onClick={() => { history.push("./compartilhados") }} >
            <IonIcon color="light" icon={shareSocial}></IonIcon>
          </IonFabButton>
        </IonFab> */}

        {/* <IonFab vertical="bottom" horizontal="end" slot="fixed" edge style={{ "bottom": "86px" }} hidden={window.localStorage.getItem("empresaTelefone") ? false : true}>

          <IonFabButton color="tertiary">
            <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (window.localStorage.getItem("empresaTelefone") || "")}>
              <IonIcon color="light" size="large" icon={chatbubbles} />
            </a>
          </IonFabButton>
        </IonFab> */}

        <IonSlides className={"ProjetosSlides"} ref={slides} onIonSlideWillChange={nextSlide}>
          <IonSlide key="slide1">
            <div style={{ padding: "6px" }}>
              {loadItens()}
            </div>
          </IonSlide>
        </IonSlides>

        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        <IonInfiniteScroll
          threshold="100px"
          onIonInfinite={(e: CustomEvent<void>) => carregarMaisProjetos(e)}
          position="bottom"
          disabled={desabilitarInfiniteScroll}>
          <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando mais operações..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>
        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />



        <IonModal isOpen={showModalMensagem} onDidDismiss={() => { setShowModalMensagem(false); setMensagem(''); setAlertaPreenchimento(false); }} >
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle><span className="modal-title-text">Enviar mensagem</span></IonTitle>
              <IonButtons slot="start" onClick={() => { setShowModalMensagem(false); }}>
                <IonButton className="pedido-fluxo-back-button" aria-label="Voltar" fill="clear" ><IonIcon slot="icon-only" icon={arrowBack}></IonIcon></IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent class="ion-padding">
            <IonItem lines="none">
              <IonIcon hidden={!alertaPreenchimento} size="large" slot="start" src={alertCircle} color="danger" />
              <IonLabel hidden={!alertaPreenchimento} color="danger" style={{ "font-size": "14px" }} >Campo obrigatório</IonLabel>
            </IonItem>
            <IonItem lines="none">
              <IonLabel position="stacked">Mensagem</IonLabel>
              <IonTextarea style={{ "--background": "#eeeeee" }} rows={6} value={mensagem} maxlength={250} placeholder="Mensagem para a empresa" onIonInput={(e: any) => setMensagem(e.target.value)}></IonTextarea>
            </IonItem>
          </IonContent>
          <IonFooter className="ion-no-border" >
            <IonToolbar>
              <IonButton expand="block" size='large' onClick={() => { enviarMensagem(projetoId) }}>Enviar</IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>


        <IonModal isOpen={abrirAvaliar} className="my-custom-class Compartilhar" onDidDismiss={() => setAbrirAvaliar(false)}>
          <IonHeader className="ion-no-border">
            <IonToolbar onClick={() => setAbrirAvaliar(false)}>
              <IonTitle><span className="modal-title-text">Avaliar</span></IonTitle>
              <IonButtons slot="start">
                <IonButton className="pedido-fluxo-back-button" aria-label="Voltar" fill="clear" ><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <div><br /></div>
            <IonItem lines="none">

              <IonIcon hidden={!alertaPreenchimento} src={alertCircle} color="danger" slot="end" />
              <IonNote hidden={!alertaPreenchimento} color="danger" slot="end" style={{ "font-size": "14px" }} >Campo obrigatório</IonNote>
            </IonItem>
            <IonItem lines="none">
              <IonLabel>Escolha de 1 a 5 estrelas para avaliar</IonLabel>

            </IonItem>
            <IonItem lines="full" style={{ "margin-bottom": "20px" }}>
              <div className="avaliarComentar">
                <div className="avaliacaoEstrela">
                  <BeautyStars
                    value={valorEstrela}
                    onChange={value => { setAlertaPreenchimento(false); setValorEstrela(value); ajustaTextoEstrela(value); setAbrirAvaliar(true); }}
                    editable={true}
                  />
                </div>
              </div>
            </IonItem>
            <IonItem lines="none">
              <IonLabel>
                Deixar comentário
              </IonLabel>
            </IonItem>
            <IonItem lines="none">
              <IonTextarea rows={3}
                value={comentario}
                style={{ "margin": "5px", "padding": "5px", "border-width": "1px", "border-style": "solid", "border-color": "#e0e0e0", "margin-top": "10px", "margin-right": "10px", "background": "#f2f2f2" }}
                placeholder="Conte-nos o que aconteceu (opcional)"
                onIonChange={e => setComentario(e.detail.value!)}>
              </IonTextarea>
            </IonItem>
          </IonContent>
          <IonFooter className="ion-no-border">
            <IonToolbar >
              <IonButton expand="block" onClick={() => { avaliar() }} >Avaliar</IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>

        <IonModal isOpen={showEncerrar} onDidDismiss={() => { setShowEncerrar(false); }}>
          <ProjetosCupom projeto={projetoSelecionado} closeAction={closeModalEncerrarSucess} closeActionSimple={closeModalEncerrar}></ProjetosCupom>
        </IonModal>

      </IonContent>





    </IonPage>
  );
};

export default Ordens;
